import { useTranslation } from 'react-i18next';
import './UserGiftSingleOffer.css';

export function UserGiftOfferDetails({ wizardBoxCount }: { wizardBoxCount?: number }) {
  const { t, i18n } = useTranslation();
  const ru = i18n.language.startsWith('ru');
  return <div className="user-gift-offer-details">
    <details>
      <summary>{ru ? 'Подробнее о подарке' : 'More about the gift'}</summary>
      <div className="user-gift-offer-details__contents">
        <div>
          <strong>{ru ? 'Для участников' : 'For participants'}</strong>
          <p>{ru ? 'Персональная рамка для аватара в текущей игре.' : 'A personal avatar frame in the current game.'}</p>
          <p>{ru ? 'Персональные темы и сайт без рекламы.*' : 'Personal themes and an ad-free site.*'}</p>
        </div>
        {!!wizardBoxCount && <div>
          <strong>{ru ? 'Для одной игры — статус «Волшебник»' : 'For one game — Wizard status'}</strong>
          <p>{ru ? 'Все темы для игры, персональные темы и сайт без рекламы для участников.*' : 'All game themes, personal themes and an ad-free site for participants.*'}</p>
          <p>{ru ? 'Подарочная рамка каждому участнику.' : 'A gift frame for every participant.'}</p>
        </div>}
        <p>{t('boxGift.userRecipientSelection')}</p>
        <small>{ru ? '* До 10 января 2027 года.' : '* Until January 10, 2027.'}</small>
      </div>
    </details>
  </div>;
}
